import type { Conversation, EvenementConversation, MessageConversation } from './types.ts'

export interface EtatConversation {
  messages: MessageConversation[]
  reponseEnCours: string
  outils: Array<{ nom: string; etat?: string; detail?: string }>
  erreur: string | null
}

export function appliquerEvenement(etat: EtatConversation, evenement: EvenementConversation): EtatConversation {
  switch (evenement.type) {
    case 'delta':
      return { ...etat, reponseEnCours: etat.reponseEnCours + evenement.texte }
    case 'message': {
      const message = evenement.message
      if (message.id && etat.messages.some((m) => m.id === message.id)) return { ...etat, reponseEnCours: '' }
      const dernier = etat.messages.at(-1)
      const remplaceOptimiste = message.role === 'responsable' && message.id && dernier?.role === 'responsable' && !dernier.id && dernier.texte === message.texte
      return { ...etat, messages: [...(remplaceOptimiste ? etat.messages.slice(0, -1) : etat.messages), message], reponseEnCours: '' }
    }
    case 'outil':
      return { ...etat, outils: [...etat.outils, { nom: evenement.nom, etat: evenement.etat, detail: evenement.detail }] }
    case 'fin': {
      const messages = evenement.conversation?.messages ??
        (etat.reponseEnCours ? [...etat.messages, { role: 'assistant' as const, texte: etat.reponseEnCours }] : etat.messages)
      return { ...etat, messages, reponseEnCours: '', outils: [] }
    }
    case 'erreur':
      return { ...etat, erreur: evenement.message, reponseEnCours: '', outils: [] }
  }
}

export function depuisConversation(conversation: Conversation): EtatConversation {
  return { messages: conversation.messages ?? [], reponseEnCours: '', outils: [], erreur: null }
}
